// 9fbef606107a605d69c0edbcd8029e5d
import {
  FETCH_DEPARTMENTS_REQUEST,
  FETCH_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENTS_FAILURE,
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
} from './DynamicSizeChart.actions';

const initialState = {
  departments: null,
  categoryData: null,
  loadingDepartments: false,
  loadingCategories: false,
  departmentError: null,
  categoryError: null,
  departmentTimestamp: null,
  categoryTimestamp: null,
};

const DynamicSizeChartReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEPARTMENTS_REQUEST:
      return {
        ...state,
        loadingDepartments: true,
        departmentError: null,
      };
    case FETCH_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departments: action.payload,
        departmentTimestamp: action.payload.timestamp,
        loadingDepartments: false,
        departmentError: null,
      };
    case FETCH_DEPARTMENTS_FAILURE:
      return {
        ...state,
        departmentError: action.payload,
        loadingDepartments: false,
      };
    case FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        loadingCategories: true,
        categoryError: null,
      };
    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        categoryData: {
          ...state.categoryData,
          [action.payload.departmentId]: action.payload.categories,
        },
        categoryTimestamp: action.payload.timestamp,
        loadingCategories: false,
        categoryError: null,
      };
    case FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        categoryError: action.payload,
        loadingCategories: false,
      };
    default:
      return state;
  }
};

export default DynamicSizeChartReducer;
